import axios from 'axios';
import { API_BASE_URL } from '../constants';
import { serializeControlRequestParams } from 'src/modules/data-protection/helpers/Controls';

export default class ControlService {
    static instance;

    static getInstance() {
        if (!ControlService.instance) {
            ControlService.instance = new ControlService();
        }

        return ControlService.instance;
    }

    async list(params = {}) {
        const response = await axios.get(`${API_BASE_URL}/control/annex`, {
            params: params,
            paramsSerializer: serializeControlRequestParams,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    }

    async details(controlId, params = {}) {
        const response = await axios.get(`${API_BASE_URL}/control/${controlId}/detail`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    }

    async fetchTasks(controlId, params = {}) {
        const response = await axios.get(`${API_BASE_URL}/control/${controlId}/tasks`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    }

    async fetchSections(params = {}) {
        const response = await axios.get(`${API_BASE_URL}/control/sections`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    }

    async toggleApplicable(controlId, payload) {
        const response = await axios.post(
            `${API_BASE_URL}/control/${controlId}/toggle_applicable`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
        return response.data.data;
    }

    async updateJustification(controlId, payload) {
        const response = await axios.post(
            `${API_BASE_URL}/control/${controlId}/update_justification`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
        return response.data.data;
    }

    async updateMaturityLevel(controlId, payload) {
        const response = await axios.post(
            `${API_BASE_URL}/control/${controlId}/update_maturity_level`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
        return response.data.data;
    }

    async fetchVersions(params = {}) {
        const response = await axios.get(`${API_BASE_URL}/control/soa/versions`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    }

    _getDashboardRequestConfig(params = {}) {
        return {
            params,
            paramsSerializer: serializeControlRequestParams,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        };
    }

    async dashboard(params = {}) {
        const response = await axios.get(
            `${API_BASE_URL}/control/dashboard`,
            this._getDashboardRequestConfig(params)
        );

        return response.data.data;
    }

    async dashboardSummary(params = {}) {
        return this.dashboard({
            ...params,
            light: 1,
        });
    }

    async dashboardControls(params = {}) {
        return this.dashboard({
            ...params,
            includeControlsTable: 1,
            includeLegalEntityComparison: 0,
        });
    }

    async dashboardLegalEntities(params = {}) {
        return this.dashboard({
            ...params,
            includeControlsTable: 0,
            includeLegalEntityComparison: 1,
        });
    }

    async fetchVersion(versionId, params = {}) {
        const response = await axios.get(`${API_BASE_URL}/control/soa/version/${versionId}`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    }
}
